import { query } from "./calls";

export const ForwardingQueue = {
    listOptions: () => query('SELECT id as value, name as label FROM ForwardingQueue order by name'),
}